const VARIANTS = {
  primary:   'bg-transit text-white hover:bg-transit-deep shadow-1',
  clearance: 'bg-clearance text-white hover:bg-clearance-deep shadow-1',
  secondary: 'bg-paper-raised text-ink border border-line hover:border-transit hover:text-transit-deep',
  danger:    'bg-critical-tint text-critical hover:bg-critical hover:text-white',
  ghost:     'bg-transparent text-ink-soft hover:text-ink',
};

export default function Button({ variant = 'primary', className = '', ...props }) {
  return (
    <button
      className={`font-body font-bold text-sm px-4 py-2.5 rounded-s transition-colors
        disabled:opacity-40 disabled:cursor-not-allowed active:translate-y-px
        ${VARIANTS[variant] || VARIANTS.primary} ${className}`}
      {...props}
    />
  );
}
